import * as React from "react";
import { Check } from "../form/check/check.mjs";
const CompareCheck = (props) => {
  return /* @__PURE__ */ React.createElement(
    Check,
    {
      id: "compare-check-".concat(props.id),
      labelText: props.labelText,
      onChange: props.onChange,
      value: "compare-check",
      checked: props.checked,
      disabled: props.disabled,
      className: "product-comparison__check"
    },
    /* @__PURE__ */ React.createElement("span", { className: "text-bold" }, props.labelText)
  );
};
export {
  CompareCheck
};
